import { useEffect } from 'react';
import { DogSchool } from '@/data/dogSchools';

interface LocalBusinessSchemaProps {
  school: DogSchool;
}

export const LocalBusinessSchema = ({ school }: LocalBusinessSchemaProps) => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `https://hundeschulenfinder.de/school/${school.id}`,
      "name": school.name,
      "image": school.imageUrl || "https://hundeschulenfinder.de/lovable-uploads/5dcadb59-e79b-45de-851e-4a6add76a6cc.png",
      "description": school.description || `Professionelle Hundeschule in ${school.city}`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": school.address || school.street || "",
        "addressLocality": school.city || "",
        "postalCode": school.postalCode || "",
        "addressRegion": school.state || "",
        "addressCountry": school.country || "DE"
      },
      "geo": school.latitude && school.longitude ? {
        "@type": "GeoCoordinates",
        "latitude": school.latitude,
        "longitude": school.longitude
      } : undefined,
      "url": school.website || `https://hundeschulenfinder.de/school/${school.id}`,
      "telephone": school.phoneNumber || school.phone || "",
      "priceRange": "$$",
      "aggregateRating": school.googleReview ? {
        "@type": "AggregateRating",
        "ratingValue": school.googleReview.toFixed(1),
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": school.reviewCount?.toString() || "10"
      } : undefined,
      "openingHoursSpecification": school.openingHours?.de ? [{
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "description": school.openingHours.de
      }] : undefined,
      "keywords": [
        `Hundeschule ${school.city}`,
        `Hundetrainer ${school.city}`,
        `Hundeschule ${school.postalCode}`,
        "Welpentraining",
        "Hundeerziehung",
        "Hundetraining in der Nähe"
      ].filter(Boolean).join(", "),
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": school.latitude && school.longitude ? {
          "@type": "GeoCoordinates",
          "latitude": school.latitude,
          "longitude": school.longitude
        } : undefined,
        "geoRadius": "20000"
      }
    };

    // Remove undefined fields
    const cleanSchema = JSON.parse(JSON.stringify(schema));

    const existingScript = document.getElementById(`local-business-${school.id}`);
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `local-business-${school.id}`;
    script.textContent = JSON.stringify(cleanSchema);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(`local-business-${school.id}`);
      if (scriptToRemove) scriptToRemove.remove();
    };
  }, [school]);

  return null;
};
